function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "5.09,15.797 17.84,3.045 77.465,3.045    90.215,15.797 90.215,109.167 77.465,121.919 17.84,121.919 5.09,109.167  "
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "14.385,23.197 25.115,12.466    70.188,12.466 80.917,23.197 80.917,101.77 70.188,112.5 25.115,112.5 14.385,101.77  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "17.84,3.045 25.115,12.466    26.287,24.997 47.652,21.42 24.965,12.514  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "14.465,22.92 22.34,62.482    26.277,24.982 14.409,23.197 5.09,15.795  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "77.84,3.045 70.565,12.466    69.393,24.997 48.027,21.42 70.715,12.514  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "81.215,22.92 73.34,62.482    69.402,24.982 81.271,23.197 90.59,15.795  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "17.84,121.919 25.115,112.5    26.287,99.968 47.652,103.544 24.965,112.451  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "14.465,102.044 22.34,62.482    26.277,99.982 14.409,101.769 5.09,109.169  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "77.84,121.919 70.565,112.5    69.393,99.968 48.027,103.544 70.715,112.451  "
}), /*#__PURE__*/React.createElement("polyline", {
  fill: "none",
  stroke: "#000000",
  strokeWidth: 2,
  strokeMiterlimit: 3.8637,
  points: "81.215,102.044 73.34,62.482    69.402,99.982 81.271,101.769 90.59,109.169  "
}));

const SvgRadiant = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  x: "0px",
  y: "0px",
  width: "94px",
  height: "124.667px",
  viewBox: "0 0 94 124.667",
  enableBackground: "new 0 0 94 124.667",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRadiant, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/radiant.009d6383.svg";
export { ForwardRef as ReactComponent };